module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6cf121d4d915bb7d0663a73aaaa4d7b4.png";